import { render } from "./BattlesReel.vue?vue&type=template&id=e0c3b630&scoped=true"
import script from "./BattlesReel.vue?vue&type=script&lang=js"
export * from "./BattlesReel.vue?vue&type=script&lang=js"

import "./BattlesReel.vue?vue&type=style&index=0&id=e0c3b630&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0c3b630"]])

export default __exports__